import type { FileStorageConfiguration } from "../types/FileStorageConfiguration"
import { MetaCache } from "@pdfking/compatibility"
import { FullMethodDispatcher } from "@pdfking/tfunc"
import { CacheStorage } from "../storage/CacheStorage"
import { ContentStorage as RemoteStorage } from "../storage/RemoteStorage"
import browser from "./browser"
import remote from "./remote"

export default FullMethodDispatcher<[FileStorageConfiguration], Promise<any>>({
  Browser: ({ db: indexed_db }) =>
    CacheStorage(MetaCache(indexed_db)).then(browser),
  Local: config => RemoteStorage(config).then(s => remote(s, config)),
})
